exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".main-language[data-v-26b64467]{margin-top:15px}.app-header.navbar .navbar-brand[data-v-26b64467]{background-image:url(\"/static/img/logo_wide%40x2.png\");background-size:80% auto}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/components/Header/Header.vue"],"names":[],"mappings":"AACA,gCACE,eAAiB,CAClB,AACD,kDACE,uDAAyD,AACzD,wBAA0B,CAC3B","file":"Header.vue","sourcesContent":["\n.main-language[data-v-26b64467] {\n  margin-top: 15px;\n}\n.app-header.navbar .navbar-brand[data-v-26b64467] {\n  background-image: url(\"~/static/img/logo_wide%40x2.png\");\n  background-size: 80% auto;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-26b64467","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header/Header.vue
// module id = 1369
// module chunks = 0